export function getAppVersion(): string {
  return window.__APP_VERSION__ ?? "dev";
}
